import { render, staticRenderFns } from "./DocumentTabs.vue?vue&type=template&id=7026c37c&scoped=true"
import script from "./DocumentTabs.vue?vue&type=script&lang=js"
export * from "./DocumentTabs.vue?vue&type=script&lang=js"
import style0 from "./DocumentTabs.vue?vue&type=style&index=0&id=7026c37c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7026c37c",
  null
  
)

export default component.exports